import(/* webpackMode: "eager" */ "/codebuild/output/src3823956198/src/legalo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3823956198/src/legalo/node_modules/next/dist/client/link.js");
